{
  "actions.logout": "Logout",
  "actions.language": "Language",
  "actions.support_request": "Support request",
  "actions.download": "Download",
  "actions.print": "Print",
  "documents.preview.cant_be_previewed": "The file can't be previewed.",
  "documents.preview.node_actions.pages": "{currentPage} of {totalPages} pages",
  "errors.error_occurred": "An error occurred",
  "actions.cancel": "Cancel",
  "actions.confirm": "Confirm",
  "actions.delete": "Delete",
  "actions.save": "Save",
  "article.new": "New knowledge base article",
  "article.create": "Create article",
  "article.edit": "Edit article",
  "article.remove": "Remove article",
  "article.state.draft": "Draft",
  "article.state.migrated": "Migrated",
  "article.state.published": "Published",
  "article.state.delete-requested": "Removal requested",
  "article.state.deleted": "Deleted",
  "article.visibility.internal": "Intern",
  "article.visibility.public": "Public",
  "folder.create": "Create folder",
  "folder.delete": "Delete folder",
  "folder.delete-confirmation": "Are you sure you want to delete this folder?",
  "chat.title": "Chat",
  "chat.all": "Chat about everything",
  "chat.kb": "Chat KB",
  "chat.kb_attachment": "KB attachment",
  "chat.ticket": "Ticket",
  "chat.jira": "Chat Jira",
  "title": "Title",
  "problem": "Problem",
  "solution": "Solution",
  "application": "Application",
  "affected-versions": "Affected versions",
  "from": "From",
  "to": "To",
  "affected-servicepack": "Service pack",
  "environment-system": "Environment / System",
  "parent-element": "Parent element",
  "visibility": "Visibility",
  "created-by": "Created by",
  "on": "on",
  "recently-edited-by": "Recently edited by",
  "edit": "Edit",
  "review-migrations": "Migrations Review",
  "review": "Review",
  "confirm-delete": "Confirm removal",
  "save-for-review": "Save for review",
  "publish": "Publish",
  "release": "Release",
  "description-problem": "Description / Problem",
  "attachments": "Attachments",
  "compare": "Compare {left} - {right}",
  "all": "All",
  "unassigned": "Unassigned",
  "id": "ID",
  "status": "Status",
  "last-editor": "Last editor",
  "edited-at": "Edited at",
  "current": "Current",
  "previous": "Previous",
  "editor": "Editor",
  "version": "Version",
  "compare-with": "Compare with",
  "main": "Main",
  "versions": "Versions",
  "request-removal": "Request removal",
  "yes-remove": "Yes, remove",
  "remove": "Remove",
  "retract": "Unpublish",
  "search": "Search ...",
  "please-specify-new-folder-name": "Please specify new folder name",
  "name": "Name",
  "unable-to-create-new-folder-error": "Unable to create new folder: {0}",
  "knowledge-base": "Knowledge Base",
  "access-denied": "Access denied",
  "article.article-needs-verification": "The article will be reviewed by another person after saving. Select the desired user.",
  "article.article-not-found": "This article was not found.",
  "article.do-not-remove-article": "Don't remove article",
  "article.do-you-want-to-remove-this-article": "Do you really want to delete this article? This cannot be undone.",
  "article.download-pdf": "Download as PDF",
  "article.removal-requires-approval": "The deletion of the article must be confirmed by a reviewer. Select the desired user.",
  "article.watch-article": "Watch article",
  "article.watched": "Watched article",
  "article.watched-article": "Watched article",
  "tickets.ticket-not-found": "The ticket was not found",
  "tickets.state.draft": "Draft",
  "tickets.state.published": "Published",
  "errors.check_your_inputs": "Check your inputs",
  "assigned": "Assigned",
  "last-reviewer": "Last reviewer",
  "page-guard.changes-not-saved": "Do you really want to leave the form? Any changes you made will not be saved.",
  "page-guard.changes-not-saved-title": "Unsaved changes",
  "continue": "Continue",
  "chat.delete_all": "Delete all chats",
  "chat.no_chats_saved": "No chats saved",
  "chat.documents": "Documents",
  "chat.course_material": "Course material",
  "chat.release_courses": "Release courses",
  "chat.misc_docs": "Other documents",
  "chat.news": "Partner news",
  "chat.release_info": "Release information",
  "chat.f1_hilfe": "F1 help",
  "chat.new_chat": "New chat",
  "article.needs_transations": "Article needs translations",
  "languages.de": "German",
  "languages.en": "English",
  "languages.fr": "French",
  "languages.it": "Italian",
  "language-not-supported": "Language not supported",
  "edit-translation": "Edit translation",
  "save-translation": "Save translation",
  "error": "Error",
  "article.versions.to": "Until",
  "article.versions.from": "From",
  "servicepack": "Service pack",
  "max-count": "max. {0}",
  "article.versions.from_to_entry": "From / To entry",
  "select-applications": "Select applications",
  "load-applications": "Loading applications",
  "select-servicepack": "Select service pack",
  "load-servicepacks": "Loading service packs",
  "select-version": "Choose version",
  "load-versions": "Loading versions",
  "chat.reply_stopped": "This reply has been aborted",
  "report": "Report",
  "open-source": "Open source",
  "sources": "Sources",
  "matches": "Matches",
  "chat.sources_empty_text": "As soon as you ask a question, the matches will appear here.",
  "chat.empty_text": "How can I help you today?",
  "hello": "Hello",
  "chat.filter.collection.all": "All",
  "chat.prompt_placeholder": "Ask your question",
  "send": "Send",
  "chat.report_answer": "Report answer",
  "chat.your_message": "Your message",
  "chat.diagram_loading": "Generating diagram…",
  "chat.diagram_open": "Open diagram",
  "chat.diagram_filename": "diagram.png",
  "cancel": "Cancel",
  "refresh": "Refresh",
  "to-migrate": "To migrate",
  "not-assigned": "Not assigned",
  "to-do": "To do",
  "article.dashboard.external_user.welcome_text": "To find the desired Knowledge Base article, use the search field or select a category.",
  "last-updated": "Last updated",
  "old": "Old",
  "new": "New",
  "summary": "Summary",
  "tickets.support_request": "Support request",
  "clarifications": "Clarifications",
  "to-review": "To review",
  "tickets.ticket_no": "Ticket No.",
  "date": "Date",
  "tickets.needs_transations": "Ticket needs translations",
  "users.group_search_or_select": "Search or select group",
  "users.favorites": "Favorites",
  "users.all_users": "All users",
  "users.favorite_add": "Add to favorites",
  "users.favorite_remove": "Remove from favorites",
  "users.user_search_or_select": "Search or select user",
  "admin.title": "Admin",
  "admin.chat.reports": "Chat reports",
  "article.errors.save_conflict": "The article has been edited by someone else in the meantime. Please reload the page and try again.",
  "tickets.errors.save_conflict": "The ticket has been edited by someone else in the meantime. Please reload the page and try again.",
  "project": "Project",
  "article.language.alert.translation_text": "{lang} translation of this article",
  "article.language.alert.english": "English",
  "article.language.alert.french": "French",
  "article.language.alert.italian": "Italian",
  "article.language.alert.only_relevant_fields": "Only relevant fields for the translation are displayed.",
  "article.language.show_original": "Show original (DE)",
  "article.language.original_article": "Original article (DE)",
  "admin.chat.table_headers.report": "Report",
  "admin.chat.table_headers.chat_filter": "Chat filters",
  "admin.chat.table_headers.reported_by": "Reported by",
  "admin.chat.table_headers.reported_on": "Reported on",
  "admin.chat.detail_title": "Chat Report Details",
  "tickets.back_to_list": "Back to the list",
  "tickets.show_old": "Show OLD",
  "filter": "Filter",
  "my-employee-group": "My employee group",
  "preview": "Preview",
  "preview.previous_attachment": "Previous attachment",
  "preview.next_attachment": "Next attachment",
  "article.restore_this_revision": "Restore this version",
  "page-guard.back-to-form": "Back to the form",
  "page-guard.discard-changes": "Discard changes",
  "time.just_now": "just now",
  "time.yesterday_at": "yesterday at",
  "is-saving": "Saving",
  "last-saved": "Last saved",
  "article.discard_my_changes": "Cancel my changes",
  "article.no_changes_yet": "no changes yet",
  "actions.close": "Close",
  "article.autosave.hint_not_up_to_date": "This article has been edited by someone else. Therefore, your changes may be outdated. You can discard your changes to then edit the current state.",
  "article.autosave.hint_saved_changes": "You have saved changes for this article.",
  "outdated": "Outdated",
  "article.autosave.version_status": "Status",
  "article.autosave.pending_changes": "My open changes",
  "article.autosave.load_error": "Your saved progress could not be loaded. Do you still want to open the article? Your saved progress could be overwritten.",
  "open-anyway": "Open anyway",
  "article.autosave.show_my_changes": "View my changes",
  "article.migrated_alert": "This article has not been revised since migrating from the old KB.",
  "development": "Development",
  "select-reviewer": "Select reviewer",
  "users.select_group_text": "Select the desired group.",
  "tickets.state.not_relevant": "Not relevant",
  "tickets.state.migrated": "Migrated",
  "tickets.state.not_relevant_requested": "Not relevant requested",
  "tickets.unused_requires_approval": "This action must be confirmed by a reviewer. Select the desired user.",
  "tickets.change_to_relevant": "Change to relevant",
  "tickets.confirm_not_relevant": "Confirm not relevant",
  "tickets.ticket_not_relevant": "Ticket is not relevant",
  "count-selected": "{0} selected",
  "assign": "Assign",
  "assign-group": "Assign group",
  "group": "Group",
  "users.select_user_text": "Select the desired user.",
  "tickets.assign_ticket_count": "Assign {0} tickets",
  "tickets.assign_group_count": "Assign {0} tickets to a group",
  "chat.delete_all_msg": "Are you sure you want to delete all chats?",
  "chat.deleta_all_confirm": "Yes, delete",
  "reject": "Reject",
  "folder.rename": "Rename folder",
  "unable-to-rename-folder-error": "Could not rename folder: {0}",
  "move": "Move",
  "yes-move": "Yes, move",
  "tree.really_move": "Are you sure you want to move <b>{0}</b> to <b>{1}</b>?",
  "tree.folder_to_kb_warning": "A directory cannot be moved to a KB.",
  "tree.really_move_to_root": "Are you sure you want to move <b>{0}</b> to the <b>top level</b>?",
  "tree.hint_search_result": "{0} of {1} results",
  "nothing-found": "Nothing found",
  "tickets.keep_original": "Keep the original ticket",
  "article.visibility.c3_internal_it": "C3 Internal IT",
  "article.visibility.c3_deepcloud": "C3 DeepCloud",
  "description": "Description",
  "jira.jira_not_found": "The Jira ticket was not found or you do not have access.",
  "jira.labels.components": "Component(s)",
  "jira.labels.solution_versions": "Solution version(s)",
  "created": "Created",
  "author": "Author",
  "priority": "Priority",
  "jira.labels.external_contacts": "External contacts",
  "jira.labels.affected_versions": "Affected version(s)",
  "last-modified": "Last modified",
  "details": "Details",
  "type": "Type",
  "modified": "Modified",
  "kb.edit.insert-attachment-link": "Attachment",
  "comments": "Comments",
  "jira.comments.edited": "edited",
  "jira.comments.no_comments": "No comments yet",
  "jira.comments.sort_newest_first": "Newest first",
  "jira.comments.sort_oldest_first": "Oldest first",
  "save": "Save",
  "change-status": "Change status",
  "admin.chat.status.new": "New",
  "admin.chat.status.read": "Read",
  "admin.chat.status.in_progress": "In Progress",
  "admin.chat.status.fixed": "Fixed",
  "admin.chat.status.wont_fix": "Will not be fixed",
  "admin.chat.set_status_dialog.note": "Note (optional)",
  "admin.chat.admin_note": "Admin note",
  "admin.chat.handled_by": "Handled by {name} on {date}",
  "watchers": "Watchers",
  "jira.errors.watchers_refresh": "The list of the watchers could not be updated",
  "jira.no_watchers_yet": "No watchers yet",
  "jira.watched": "Watched",
  "jira.watch": "Watch",
  "jira.filter.only_watched": "Only watched",
  "jira.no_attachments": "No attachments",
  "jira.links.title": "Links",
  "jira.links.remote_group": "is linked to",
  "jira.links.no_links": "No links",
  "notifications.settings.title": "Email notifications",
  "notifications.settings.description": "Choose which events you want to be notified about by email.",
  "notifications.settings.saved": "Settings updated",
  "notifications.settings.event_type.kb_followed_article_changed": "Changes to followed KB articles",
  "notifications.settings.event_type.kb_review_approved": "Approval of an edited KB article",
  "notifications.settings.event_type.kb_review_rejected": "Rejection of an edited KB article",
  "notifications.settings.event_type.kb_assigned": "Assignment of a KB article",
  "notifications.settings.event_type.ticket_review_approved": "Approval of an edited ticket",
  "notifications.settings.event_type.ticket_review_rejected": "An edited ticket being marked as not usable",
  "notifications.settings.event_type.ticket_assigned": "Assignment of a ticket",
  "notifications.settings.event_type.jira_followed_issue_updated": "Changes to followed Jira issues",
  "tickets.state.not_relevant_ai": "Not relevant (AI)",
  "wish_ticket.open": "Feature request form",
  "wish_ticket.title": "Feature requests for the application",
  "wish_ticket.email": "Email",
  "wish_ticket.customer_name": "Customer name",
  "wish_ticket.customer_license": "Customer license",
  "wish_ticket.section_description": "Request description",
  "wish_ticket.description": "Detailed description of the requirement (initial situation, current behavior vs. expected behavior)",
  "wish_ticket.use_cases": "Which use cases (user stories) should be covered / supported?",
  "wish_ticket.frequency.label": "How often does this use case occur? How often could the new feature be used?",
  "wish_ticket.frequency.multiple_per_day": "Frequently (several times a day)",
  "wish_ticket.frequency.multiple_per_week": "Often (several times a week)",
  "wish_ticket.frequency.weekly_monthly": "Regularly (once a week/month)",
  "wish_ticket.frequency.rarely": "Rarely (once a year, occasionally)",
  "wish_ticket.frequency.once": "Once",
  "wish_ticket.target_audience": "Who is the new feature intended for? (e.g. accountants, employees, sales partners, fiduciaries, etc.)",
  "wish_ticket.benefit": "What overall benefit can be gained from this extension? (e.g. process simplification, efficiency gains, automation, etc.)",
  "wish_ticket.discussed_with_abacus": "Has the request already been discussed with someone at Abacus Research AG?",
  "wish_ticket.yes": "Yes",
  "wish_ticket.no": "No",
  "wish_ticket.additional_info": "Additional information (Who was it discussed with? Is there already a known Jira or KB?)",
  "wish_ticket.privacy": "Privacy",
  "wish_ticket.privacy_text": "I have taken note of the {link}.",
  "wish_ticket.privacy_link": "privacy policy",
  "wish_ticket.submit": "Send request",
  "wish_ticket.sent": "Your request has been sent",
  "wish_ticket.please_select": "– please select –",
  "live_status.button": "Status",
  "live_status.title": "Service status",
  "live_status.all_ok": "All systems operational",
  "live_status.issue": "Some services are impaired",
  "live_status.unreachable": "Service status could not be retrieved",
  "live_status.loading": "Loading service status…",
  "ops.cases": "Cases",
  "ops.case.create": "Create case",
  "ops.case.delete": "Delete case",
  "ops.case.delete_confirmation": "Do you really want to delete this case? It will disappear from all lists and from the chat.",
  "ops.case.deleted": "Case deleted",
  "ops.case.saved": "Case saved",
  "ops.case.load_error": "The case could not be loaded.",
  "ops.case.required": "Required",
  "ops.case.case_no": "Case number",
  "ops.case.case_no_pending": "Assigned on save",
  "ops.case.folder": "Folder",
  "ops.case.reported_at": "Reported on",
  "ops.case.affected_users": "Affected users",
  "ops.case.os": "OS",
  "ops.case.os_build": "OS build",
  "ops.case.version_patch": "Abacus version / patch",
  "ops.case.applications": "Affected applications",
  "ops.case.frequency": "Frequency / regularity",
  "ops.case.frequency_hint": "e.g. every day at noon, always on the 24th",
  "ops.case.programs": "Affected programs",
  "ops.case.services": "Affected services",
  "ops.case.required_data": "Data required for analysis",
  "ops.case.required_data_hint": "e.g. heap dump and sysinfo",
  "ops.case.jira_keys": "Affected Jiras",
  "ops.case.ticket_numbers": "Affected tickets",
  "ops.case.workarounds": "Workarounds",
  "ops.case.solutions": "Solutions",
  "ops.analysis.title": "Analyses",
  "ops.analysis.add": "Add analysis",
  "ops.analysis.count": "Analyses",
  "ops.analysis.empty": "No analyses recorded yet.",
  "ops.analysis.entry_title": "Analysis {0}",
  "ops.analysis.saved": "Analysis saved",
  "ops.analysis.delete": "Delete analysis",
  "ops.analysis.delete_confirmation": "Do you really want to delete this analysis including its files?",
  "ops.analysis.cpu": "CPU",
  "ops.analysis.memory": "Memory",
  "ops.analysis.diskspeed": "Disk speed",
  "ops.analysis.abacus_services": "Abacus services",
  "ops.analysis.procedure": "Analysis / procedure",
  "ops.analysis.log_entries": "Log entries",
  "ops.analysis.thread_stack": "Decisive thread stack",
  "ops.analysis.heapdump_ref": "Heap dump reference",
  "ops.analysis.heapdump_ref_hint": "Path or link to the heap dump (no upload)",
  "ops.files.title": "Files (thread dump, Prometheus dump, …)",
  "ops.files.hint": "Max. {0} per file",
  "ops.files.too_large": "\"{0}\" is larger than {1} and cannot be uploaded. Shrink or split the file.",
  "servicepack_none": "No service packs",
  "ops.case.folder_root": "Top level (no folder)",
  "ops.analysis.edit": "Edit analysis",
  "ops.analysis.files_after_save": "Save the analysis first to attach files.",
  "ops.analysis.no_details": "No details recorded.",
  "ops.analysis.file_count": "{0} file(s)",
  "ops.case.edit": "Edit case",
  "ops.case.affected_users_hint": "Count"
}
